import { useState, useEffect } from "react";

function usePagination(
  products,
  setCurrentProducts,
  productPerPage,
  setIndexing,
) {
  const [currentPage, setCurrentPage] = useState(1);
  const lastIndex = currentPage * productPerPage;
  const firstIndex = lastIndex - productPerPage;

  const nPage = products && Math.ceil(products.length / productPerPage);

  const shortedProducts =
    products &&
    products.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));

  const slicedProducts = shortedProducts.slice(firstIndex, lastIndex);

  const pageNumbers = products && [...Array(nPage + 1).keys()].slice(1);
  const adjustIndex = (index) => {
    setCurrentPage(index);
    setIndexing(index);
  };

  useEffect(() => {
    if (products) {
      setCurrentProducts(slicedProducts);
    }
  }, [products, currentPage]);

  const setPage = (newPage) => {
    if (newPage >= 1 && newPage <= nPage) {
      adjustIndex(newPage);
    }
  };

  const nextPage = () => {
    if (currentPage !== lastIndex) {
      setPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage !== firstIndex && currentPage > 1) {
      setPage(currentPage - 1);
    }
  };

  return {
    pageNumbers,
    slicedProducts,
    nextPage,
    previousPage,
    currentPage,
    productPerPage,
  };
}

export default usePagination;
